export default __webpack_public_path__ + "static/services2-e0ab2a0baf5cbed0845e1afed3d020a6.png";